import type { RegisteredSkill, SkillDescriptor, SkillHandler } from '../../types'

export function toSkillDescriptors(skills: RegisteredSkill[]): SkillDescriptor[] {
  return skills.map(({ name, description, argsSchema, resultSchema }) => ({
    name,
    description,
    argsSchema,
    resultSchema,
  }))
}

export function createListSkillsHandler(getAllSkills: () => RegisteredSkill[]): SkillHandler {
  return async () => ({ ok: true, content: toSkillDescriptors(getAllSkills()) })
}
